'use strict';

require("core-js/modules/es6.object.is");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.map");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
}; //----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------
// --[ Dependencies ]---------------------------------------------------


var _require = require('../union'),
    tagSymbol = _require.tagSymbol,
    typeSymbol = _require.typeSymbol; // --[ Helpers ]--------------------------------------------------------

/*~
 * type: (Object Any) => String
 */


var objectToKeyValuePairs = function objectToKeyValuePairs(object) {
  return Object.keys(object).map(function (key) {
    return key + ': ' + showValue(object[key]);
  }).join(', ');
};
/*~
 * type: (Object Any).() => String
 */


var plainObjectToString = function plainObjectToString() {
  return '{ ' + objectToKeyValuePairs(this) + ' }';
};
/*~
 * type: (Array Any).() => String
 */


var arrayToString = function arrayToString() {
  return '[' + this.map(showValue).join(', ') + ']';
};
/*~
 * type: (Function) => String
 */


var functionNameToString = function functionNameToString(fn) {
  return fn.name !== '' ? ': ' + fn.name : '';
};
/*~
 * type: (Function) => String
 */


var functionToString = function functionToString(fn) {
  return '[Function' + functionNameToString(fn) + ']';
};
/*~
 * type: () => String
 */


var nullToString = function nullToString() {
  return 'null';
};
/*~
 * type: (Any) => Bool
 */


var isPlainObject = function isPlainObject(object) {
  return !object.toString || object.toString === Object.prototype.toString;
};
/*~
 * type: (Null | Object Any) => String
 */


var objectToString = function objectToString(object) {
  return object === null ? nullToString : Array.isArray(object) ? arrayToString : isPlainObject(object) ? plainObjectToString :
  /* otherwise */
  object.toString;
};
/*~
 * type: (Any) => String
 */


var showValue = function showValue(value) {
  return typeof value === 'undefined' ? 'undefined' : typeof value === 'function' ? functionToString(value) : Object.is(value, -0) ? '-0' : typeof value === 'number' ? value : (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'symbol' ? value.toString() : (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? objectToString(value).call(value) :
  /* otherwise */
  JSON.stringify(value);
}; // --[ Implementation ]------------------------------------------------

/*~
 * stability: experimental
 * authors:
 *   - "@boris-marinov"
 * 
 * type: |
 *   (Variant, Union) => Void
 */


var debugRepresentation = function debugRepresentation(variant, adt) {
  // eslint-disable-line max-statements
  var typeName = adt[typeSymbol];
  var variantName = adt[typeSymbol] + '.' + variant.prototype[tagSymbol]; // (for Object.prototype.toString)

  adt[Symbol.toStringTag] = typeName;
  variant.prototype[Symbol.toStringTag] = variantName; // (regular JavaScript representations)

  /*~
   * stability: experimental
   * module: null
   * authors:
   *   - "@boris-marinov"
   * 
   * type: |
   *   () => String
   */

  adt.toString = function () {
    return typeName;
  };
  /*~
   * stability: experimental
   * mmodule: null
   * authors:
   *   - "@boris-marinov"
   * 
   * type: |
   *   () => String
   */


  variant.toString = function () {
    return variantName;
  };
  /*~
   * stability: experimental
   * module: null
   * authors:
   *   - "@boris-marinov"
   * 
   * type: |
   *   (Union).() => String
   */


  variant.prototype.toString = function () {
    return variantName + '(' + plainObjectToString.call(this) + ')';
  }; // (Node REPL representations)


  adt.inspect = adt.toString;
  variant.inspect = variant.toString;
  variant.prototype.inspect = variant.prototype.toString;
  return variant;
}; // --[ Exports ]-------------------------------------------------------


module.exports = debugRepresentation;